import React, { Component } from "react";
import PropTypes from "prop-types";
import { ReactComponent as Close } from "./icons/close.svg";
import { ReactComponent as Ok } from "./icons/ok.svg";
import { ReactComponent as Info } from "./icons/info.svg";
import styles from "./styles";

class SnackBar extends Component {

  static propTypes = {
    classes: PropTypes.object.isRequired,
    snackBarMessages: PropTypes.array.isRequired,
    removeMessage: PropTypes.func.isRequired,
    removeAllMessages: PropTypes.func.isRequired,
    maxErrorTextLength: PropTypes.number,
  };

  static defaultProps = {
    maxErrorTextLength: 300,
  };

  handleOnCLick = (key) => {
    this.props.removeMessage(key);
  };

  handleOnClose = (key, type) => {
    if (type !== "error") {
      setTimeout(() => this.handleOnCLick(key), 5000);
    }
    return true;
  };

  checkIcon = (type) => {
    if (type === "error") {
      return <Close className={this.props.classes.messageIcon} />;
    }
    if (type === "success") {
      return <Ok className={this.props.classes.messageIcon} />;
    }
    return <Info className={this.props.classes.messageIcon} />;
  };

  dataTestName = (type) => `snack-bar-${type}`;

  render = () =>
    <div className={this.props.classes.root}>
      {this.props.snackBarMessages.map(({ key, title, message, type }) => (
        <div
          className={this.props.classes[type]}
          data-test={this.dataTestName(type)}
          onClick={() => this.handleOnCLick(key)}
        >
          <div className={this.props.classes.message}>
            {this.checkIcon(type)}
            <div className={this.props.classes.messageText}>
              <div>
                  <span className={this.props.classes.messageTitle}>
                    {title}
                  </span>
              </div>
              <span className={this.props.classes.messageBody}>
                  {type === "error" ? message.substring(0, this.props.maxErrorTextLength) : message}
                </span>
            </div>
          </div>
        </div>
      ))}
    </div>;
}

export default styles(SnackBar);
